<div>
  <!--#region fields  -->
  <!--textType-->
  <!-- TODO textarea torbatian -->
  <mat-form-field
    appearance="outline"
    class="tw-w-full"
    *ngIf="input_type != 'dateTime' && input_type != 'enum'"
  >
    <mat-label class="tw-text-[15px] tw-pr-[25px] ltr:tw-pl-[25px]">
      {{ label | translate }}
    </mat-label>

    <!--input-->
    <div class="tw-pr-[22px] ltr:tw-pl-[22px]">
    <input
      matInput
      *ngIf="input_type != 'textArea' && input_type !== 'smsText'"
      type="text"
      [onlyNumbers]="input_isOnlyNumber"
      matInput
      class="tw-text-lg font-vazir-ui"
      [(ngModel)]="value"
      [ngModelOptions]="{ standalone: true }"
      (input)="emit()"
    />
  </div>

    <!--textArea-->
    <div
      class="tw-flex tw-pr-[22px] ltr:tw-pl-[22px]"
      *ngIf="input_type == 'textArea' || input_type == 'smsText'"
    >
      <textarea
        class="font-vazir-ui"
        matInput
        rows="2"
        [(ngModel)]="value"
        [ngModelOptions]="{ standalone: true }"
        (change)="emit()"
      ></textarea>
    </div>

    <!--icons-->
    <i
      class="tw-right-0 tw-top-[17px] tw-text-[22px] tw-ml-1 menu-btn text-navyBlue tw-cursor-pointer tw-absolute"
      [matMenuTriggerData]="{ field: input_fieldName, type: input_type }"
      [matMenuTriggerFor]="menu"
      [class]="'mdi ' + operatorIcons[input_operator]"
    ></i>

    <mat-icon
      *ngIf="value"
      class="clear dark:tw-text-gray-400"
      matSuffix
      (click)="clearValue(input_fieldName)"
      >clear</mat-icon
    >
  </mat-form-field>

  <div *ngIf="input_type == 'enum'">
    <enum-select-search
      [enumName]="input_enumName"
      [label]="label"
      [(value)]="value"
      (valueChange)="emit()"
    >
    </enum-select-search>
  </div>

  <div class="tw-flex" *ngIf="input_type == 'dateTime'">
    <!-- start date time picker -->
    <app-periodic-date-time-picker
      class="tw-w-full"
      [config]="periodicDateTimeConfig"
      (startDateTime)="startDateTime = $event; emitStartDate()"
      (endDateTime)="endDateTime = $event; emitEndDate()"
    >
    </app-periodic-date-time-picker>
  </div>

  <!--#endregion -->

  <!--#region matMenu  -->

  <!--------------------- matMenu  ----------------------->

  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-field="field" let-type="type">
      <!--Operators For Number -->
      <ng-container *ngIf="type == 'number'">
        <div
          *ngFor="let ComparisonOperator of numberOperators"
          class="menu-item tw-py-1 border-bottom"
          (click)="submitWithOperator(ComparisonOperator, field)"
        >
          <!-- icon -->
          <span [class]="input_operator == ComparisonOperator ? 'active' : ''">
            <i
              [class]="
                'mdi mdi-18px tw-text-gray-600 ' +
                operatorIcons[ComparisonOperator]
              "
            ></i>
          </span>
          <!-- text -->
          <span class="tw-mr-1 search-item__text tw-text-gray-600">{{
            ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
          }}</span>
        </div>
      </ng-container>
      <!--Operators For Text -->
      <ng-container *ngIf="type == 'text' || type == 'textArea'">
        <div
          *ngFor="let ComparisonOperator of textOperators"
          class="menu-item tw-py-1 border-bottom"
          (click)="submitWithOperator(ComparisonOperator, field)"
        >
          <!-- icon -->
          <span [class]="input_operator == ComparisonOperator ? 'active' : ''">
            <i
              [class]="
                'mdi mdi-18px tw-text-gray-600 ' +
                operatorIcons[ComparisonOperator]
              "
            ></i>
          </span>
          <!-- title -->
          <span class="tw-mr-1 search-item__text tw-text-gray-600">{{
            ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
          }}</span>
        </div>
      </ng-container>

      <!--Operators For ToNumber -->
      <ng-container *ngIf="type == 'toNumber'">
        <div
          *ngFor="let ComparisonOperator of toNumberOperators"
          class="menu-item tw-py-1 border-bottom"
          (click)="submitWithOperator(ComparisonOperator, field)"
        >
          <!-- icon -->
          <span [class]="input_operator == ComparisonOperator ? 'active' : ''">
            <i
              [class]="
                'mdi mdi-18px tw-text-gray-600 ' +
                operatorIcons[ComparisonOperator]
              "
            ></i>
          </span>
          <!-- title -->
          <span class="tw-mr-1 search-item__text tw-text-gray-600">{{
            ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
          }}</span>
        </div>
      </ng-container>

      <!--Operators For smsText -->
      <ng-container *ngIf="type == 'smsText'">
        <div
          *ngFor="let ComparisonOperator of smsTextOperators"
          class="menu-item tw-py-1 border-bottom"
          (click)="submitWithOperator(ComparisonOperator, field)"
        >
          <!-- icon -->
          <span [class]="input_operator == ComparisonOperator ? 'active' : ''">
            <i
              [class]="
                'mdi mdi-18px tw-text-gray-600 ' +
                operatorIcons[ComparisonOperator]
              "
            ></i>
          </span>
          <!-- title -->
          <span class="tw-mr-1 search-item__text tw-text-gray-600">{{
            ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
          }}</span>
        </div>
      </ng-container>
      <!--Operators For enum -->
      <ng-container *ngIf="type == 'enum'">
        <div
          *ngFor="let ComparisonOperator of enumOperators"
          class="menu-item tw-py-1 border-bottom"
          (click)="submitWithOperator(ComparisonOperator, field)"
        >
          <!-- icon -->
          <span [class]="input_operator == ComparisonOperator ? 'active' : ''">
            <i
              [class]="
                'mdi mdi-18px tw-text-gray-600 ' +
                operatorIcons[ComparisonOperator]
              "
            ></i>
          </span>
          <!-- title -->
          <span class="tw-mr-1 search-item__text tw-text-gray-600">{{
            ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
          }}</span>
        </div>
      </ng-container>
    </ng-template>
  </mat-menu>

  <!--#endregion -->
</div>
